export default function truncateText(value, length) {
    if (!value) return '';
        value = value.toString();
    if (value.length <= length) {
      return value;
    }
    return value.substring(0, length) + '...';
}